import {
  parseAsString,
  useQueryStates,
  type HistoryOptions,
} from '@vrplatform/query-params';

type View = 'overview' | 'edit';

export function useUserAccessDetailDrawer() {
  const [opts, set] = useQueryStates({
    'owner-user': parseAsString,
    view: parseAsString,
  });

  return {
    opened: !!opts['owner-user'],
    open: (id: string, view?: 'overview' | 'edit', type?: HistoryOptions) =>
      set(
        { 'owner-user': id, view },
        {
          history: type || 'push',
        }
      ),
    close: () => set(null),
    ownerId: opts['owner-user'],
    view: (opts.view || 'overview') as View,
    setView: (view: View) => set({ view }),
  };
}
